import { useMutation } from '@tanstack/react-query';
import { downloadBlob } from '@/shared/utils/download-blob.util';

interface DownloadDocumentPdfParams {
  url: string;
  filename: string;
}

export function useDocumentPdf() {
  return useMutation({
    retry: false,
    mutationFn: async ({ url, filename }: DownloadDocumentPdfParams) => {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Falha ao baixar o PDF');
      const blob = await response.blob();
      downloadBlob(blob, filename);
    },
  });
}
